module.exports = __webpack_public_path__ + "img/berryGlow2.d2dc2392.jpg";